import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import {
  userHasPermission,
  formatDateTimeWithDayFirst,
} from "@/modules/common/utils";
import EditDateOfLastRequest from "@/modules/lead-page/components/lead-info/edit-fields/date-of-last-request";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";
import LeadInfoField from "@/modules/lead-page/new/components/lead-info-field";
import FieldWrapper from "@/modules/lead-page/new/components/sidebar/fields/field-wrapper";
import { Typography, useTheme } from "@mui/material";
import { useContext } from "react";

const LastRequestField = () => {
  const theme = useTheme();
  const { dateOfLastRequest, lead, isLoading, handleConfirmUpdate } =
    useLeadInfo();
  const { permissions: currentUserPermissions } =
    useContext(NawyPassportContext);

  return (
    <LeadInfoField
      editModalOpen={dateOfLastRequest.editLeadDateOfLastRequestModalOpen}
      setEditModalOpen={dateOfLastRequest.setEditLeadDateOfLastRequestModalOpen}
      editable={userHasPermission(
        {
          name: PermissionsEnum.JOURNEY_DATE_OF_LAST_REQUEST,
          level: PermissionLevel.WRITE,
        },
        currentUserPermissions
      )}
      content={
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.md.regular,
            display: "inline",
            whiteSpace: "nowrap",
          }}
        >
          {lead?.data?.lead?.date_of_last_request
            ? (() =>
                formatDateTimeWithDayFirst(
                  lead?.data?.lead?.date_of_last_request || ""
                ))()
            : "Not Set"}
        </Typography>
      }
      editModal={
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.JOURNEY_DATE_OF_LAST_REQUEST,
              level: PermissionLevel.WRITE,
            },
          ]}
        >
          <ResponsiveModal
            open={dateOfLastRequest.editLeadDateOfLastRequestModalOpen}
            onClose={() => {
              dateOfLastRequest.setEditLeadDateOfLastRequestModalOpen(false);
              dateOfLastRequest.setState(null);
            }}
            onConfirm={() => {
              handleConfirmUpdate({
                lead: {
                  dateOfLastRequest: dateOfLastRequest.state ?? undefined,
                },
              });
              dateOfLastRequest.setState(null);
            }}
            isConfirmDisabled={!dateOfLastRequest.state}
            isLoading={isLoading}
            title="Select Date"
            confirmButtonText="Save"
            cancelButtonText="Cancel"
            snapPoints={[1]}
          >
            <FieldWrapper>
              <EditDateOfLastRequest
                autoFocus
                dateOfLastRequest={dateOfLastRequest}
              />
            </FieldWrapper>
          </ResponsiveModal>
        </PermissionGuard>
      }
    />
  );
};

export default LastRequestField;
